import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IStudyAdvantages } from '../types'
import { useStudyAdvantages } from '../bll'

const Count = styled.div`
  margin-top: 2px;
  background-color: ${sv.color.blue};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-weight: ${sv.fontWeight.semibold};
  font-size: ${sv.fontSize.small2};
`

const StudyAdvantages: FC<IStudyAdvantages> = (props) => {
  const { features } = props

  const list = useStudyAdvantages(features)

  return (
    <div>
      <Heading h3='Преимущества обучения' spacing='small' />

      <Grid spacing='xlarge'>
        {list.map((item, index) => (
          <GridCol key={item.id} uxs={12}>
            <Grid spacing='xxsmall'>
              <GridCol width='auto'>
                <Count>{index + 1}</Count>
              </GridCol>

              <GridCol width='auto' shrink='1'>
                <Text
                  firstLetterUppercase
                  fontSize='h4'
                  lineHeight='h4'
                  fontWeight='bold'
                >
                  {item.title}
                </Text>
              </GridCol>
            </Grid>

            <Spacing spacing='xxsmall' />

            <Text firstLetterUppercase>{item.description}</Text>
          </GridCol>
        ))}
      </Grid>
    </div>
  )
}

export default StudyAdvantages
